import MapContactScreen from "./map";
import ContactForm from "./contactForm";
import PageTitle from "../common/pageTitle";

function Contact() {
  return (
    <div className="my-5 px-5 w-full">
      <PageTitle title={"Contact"} />
      <MapContactScreen />
      <ContactForm />
    </div>
  );
}

export default Contact;
